<h2>{{ config.title }}</h2>

<img src="../../../../../assets/img/{{ config.imgFileName }}.png" alt="" />
